import React from 'react';
import { FaLongArrowAltRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useEffect } from 'react';

function Location() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on page load
  }, []);

  return (
    <div>
      {/* WAVE Hero */}
      <div className='about-hero'>
        <div className='about-hero-inner d-flex justify-content-center align-items-center'>
          <div>
            <h1 className='syne-title'>OUR LOCA<span className='text-rose'>T</span>IONS<span className='text-rose'>.</span></h1>
            <p className='text-center'>Home / <span className='text-rose'>Loactions</span></p>
          </div>
        </div>
      </div>
      {/* WAVE Hero */}
      {/* Home Locations */}
      <div className='home-location container-fluid py-4 bg-light'>
        <div className='home-location-inner container py-4'>
          {/* <h1 className='syne-title text-center text-uppercase'>Our Loca<span className='text-rose'>t</span>ions<span className='text-rose'>.</span></h1> */}
          <p className='mb-4 text-secondary text-center'>At Tattva Realty & Infra, we choose prime locations across Hyderabad that offer the perfect mix of accessibility, luxury, and growth potential. From city centers to peaceful suburbs, our properties ensure unmatched value, convenience, and lifestyle.</p>
          <div className='home-location-imgs container-fluid'>
            {/* //// */}
            <div className='row justify-content-center'>
              <div className='col-lg-4 col-md-6 my-3'>
                <Link to='/hyderabad'>
                  <div className='loc-hyd rounded-15'>
                    <div className='loc-shadow rounded-15'>
                      <h4 className='syne-title'><span className="text-rose ">H</span>YDERABAD</h4>
                    </div>
                  </div>
                </Link>
              </div>
              <div className='col-lg-4 col-md-6 my-3'>
                <Link to='/dubai'>
                  <div className='loc-dubai rounded-15'>
                    <div className='loc-shadow rounded-15'>
                      <h4 className='syne-title'><span className="text-rose ">D</span>UBAI</h4>
                    </div>
                  </div>
                </Link>
              </div>
              <div className='col-lg-4 col-md-6 my-3'>
                <Link to='/banglore'>
                  <div className='loc-bnglr rounded-15'>
                    <div className='loc-shadow rounded-15'>
                      <h4 className='syne-title'><span className="text-rose ">B</span>ANGLORE</h4>
                    </div>
                  </div>
                </Link>
              </div>
              <div className='col-lg-4 col-md-6 my-3'>
                <Link to='/pune'>
                  <div className='loc-pune rounded-15'>
                    <div className='loc-shadow rounded-15'>
                      <h4 className='syne-title'><span className="text-rose ">P</span>UNE</h4>
                    </div>
                  </div>
                </Link>
              </div>
              <div className='col-lg-4 col-md-6 my-3'>
                <Link to='/mumbai'>
                  <div className='loc-mumbai rounded-15'>
                    <div className='loc-shadow rounded-15'>
                      <h4 className='syne-title'><span className="text-rose ">M</span>UMBAI</h4>
                    </div>
                  </div>
                </Link>
              </div>
              <div className='col-lg-4 col-md-6 my-3'>
                <Link to='/delhiNCR'>
                  <div className='loc-delhi rounded-15'>
                    <div className='loc-shadow rounded-15'>
                      <h4 className='syne-title'><span className="text-rose ">D</span>ELHI NCR</h4>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
            {/* Additional project items can follow the same structure */}
            {/* <div className='home-about-btn text-center mt-4'>
              <Link to="/locations" className="text-rose"><FaLongArrowAltRight /> View All</Link>
            </div> */}
            {/* //// */}
          </div>



        </div>
      </div>
      {/* Home Locations */}
      {/* Home Discuss*/}
      <div className='container-fluid py-5 home-discuss'>
        <div className='container py-5 home-discuss-inner bg-light p-4 rounded-15 shadow-sm'>
          <h1 className='syne-title mb-4 text-start'>
            LET'S DISCUSS<br />YOUR IDEA<span className='text-rose'>.</span>
          </h1>
          <div className='discuss-inner'>
            <div className='row align-items-center'>
              <div className='col-lg-6'>
                <div className='discuss-left text-start'>
                  <p className='text-secondary'>
                    We’re excited to hear your vision! Whether you have a concept or need help brainstorming, our team is ready to collaborate. Let’s connect and turn your idea into reality—schedule a meeting with us today!
                  </p>
                  <div className='discuss-mail d-flex align-items-center my-3'>
                    <i className='fas fa-envelope me-2'></i>
                    <p className='mb-0 text-secondary'>rakesh.tattvahilife@gmail.com</p>
                  </div>
                  <div className='discuss-mail d-flex align-items-center my-3'>
                    <i className='fas fa-mobile-alt me-2'></i>
                    <p className='mb-0 text-secondary'>+91 88970 35800</p>
                  </div>
                  <div className='discuss-mail d-flex align-items-center my-3'>
                    <i className='fas fa-map-marker-alt me-2'></i>
                    <p className='mb-0 text-secondary'>10, Prashanthi Hills, Khajaguda, Gachibowli, Hyderabad</p>
                  </div>
                  <div className='discuss-icons d-flex'>
                    <a href='https://www.linkedin.com/in/tattva-hi-life-735094319/' target='blank' className='text-decoration-none'><i className='fab fa-linkedin-in text-white'></i></a>
                    <a href='https://x.com/TattvaHiLife' className='text-decoration-none'><i className='fab fa-twitter text-white'></i></a>
                    <a href='https://www.facebook.com/profile.php?id=100086552704523' className='text-decoration-none'><i className='fab fa-facebook-f text-white'></i></a>
                    <a href='https://www.instagram.com/tattvahilife_international/' className='text-decoration-none'><i className='fab fa-instagram text-white'></i></a>
                  </div>
                </div>
              </div>
              <div className='col-lg-6'>
                <form action="https://api.web3forms.com/submit" method="POST">
                  <input type="hidden" name="access_key" value="d567d7ce-8cc7-4fdd-a9ae-66c9c3461e68" />
                  <input
                    type='text'
                    placeholder='Name'
                    name="name"
                    className='form-control my-2'
                    required

                  />
                  <input
                    type='text'
                    placeholder='Mobile'
                    name="mobile"
                    className='form-control my-2'
                    required
                  />
                  <input
                    type='email'
                    placeholder='Email'
                    name="email"
                    className='form-control my-2'
                    required
                  />
                  <textarea
                    placeholder='Message'
                    name="message"
                    rows='4'
                    className='form-control my-2'
                    required
                  />
                  <div className='text-start mt-3 d-flex align-items-center'>
                    <span className='fs-2 text-rose'>→</span>
                    <input type='submit' value='Send' className='border-0 text-rose discuss-btn' />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Home Discuss*/}
    </div>
  )
}

export default Location